<template>
    <div class="contain_background">
        <my-header :is-back="true"
                   :title="resource.title"
                   class="header_class"
        />
        <div class="body_class">
            <div class="seal_box">
                <div class="seal_item"> <img class="seal_img" :src="resource.cover" alt=""/></div>
                <div class="text_item"><span class="title_item">{{resource.title}}</span></div>
                <div class="text_item"><span class="author_item">{{resource.author}}</span></div>
            </div>

            <div class="detail_box">
                <van-tabs v-model="active" color="#3EA1E8">
                    <van-tab title="章节">
                        <van-divider />
                        <audio-book-detail-chapter :resource="resource"/>
                    </van-tab>
                    <van-tab title="简介">
                        <van-divider />
                        <audio-book-detail-des :description="resource.description"/>
                    </van-tab>

                    <van-tab title="评论">
                        <van-divider />
                        <comment-list :item-id="resource.firstItem.id"/>
                    </van-tab>
                </van-tabs>
            </div>
        </div>

        <bottom-action-bar class="bottom_class" :btn-text="'开始播放'" @btn-click="toPlay"/>

    </div>
</template>

<script>
import myHeader from "../../../components/myHeader";
import bottomActionBar from "../../../components/bottomActionBar";
import audioBookDetailDes from "./audioBookDetailDes";
import audioBookDetailChapter from "./audioBookDetailChapter";
import LoadResource from "@/views/resource/LoadResource";
import {Toast} from "vant";
import CommentList from '@/components/commentList';
import {computed} from "vue";

export default{
    name:'audioBookDetail',
    components:{
        CommentList,
        myHeader,
        bottomActionBar,
        audioBookDetailDes,
        audioBookDetailChapter,

    },
    props:{
        id:{
            type:String,
            required:true,
        }
    },
    provide(){
        return{
            resourceId:computed(() => this.resource.id),
            resourceItemId:computed(() => {
                if(this.resource){
                    return this.resource.firstItem.id
                }
                return null;
            }),
            enableComment:computed(() =>  this.resource.enableComment)
        }
    },
    watch:{
        id(val){
            this.initLoadResource(val,true)
        }
    },
    setup(props){
        const obj = new LoadResource(props.id,true)
        const initLoadResource = (id,fetchContent) => obj.init(id,fetchContent);
        const loadResource = () => obj.loadResource();

        return{
            active:0,
            // 服务端响应数据
            resource:obj.resource,
            // 加载数据中
            loading:obj.loading,
            // 初始化，重新加载数据
            initLoadResource,
            // 加载数据
            loadResource,
        }
    },
    methods:{
        toPlay(){
            if(!this.resource){
                Toast.fail("资源正在加载中，请稍后")
                return
            }
            if(!this.resource.item || !this.resource.item.length){
                Toast.fail("当前专辑中无音频资源")
                return
            }
            this.$router.push(`/r/music/${this.resource.id}/play`)
        }
    }
}

</script>


<style scoped>
.contain_background{
    width:100vw;
    height:100vh;
    position:relative;
    background-color: RGBA(238, 238, 238, 1);
}
.header_class{
    width:100vw;
    height:50px;
    border-bottom: 1px solid lightgrey;
}

.body_class{
    width:100vw;
    height:calc(100vh - 50px - 9vh);
    overflow-y: scroll;
    overflow-x:hidden ;
    box-sizing: border-box;
    background-color: #FFFFFF;
}
.seal_box{
    width:100vw;
    /*height:50%;*/
    display:flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;

}
.seal_item{
    width:100vw;
    /*height:calc(100% - 25px - 25px);*/
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    padding-bottom: 2vw;

}
.seal_img{
    margin-top: 9.6vw;
    width:48vw;
    height:48vw;
    box-sizing: border-box;
    border-radius: 5px;
    object-fit: cover;
}
.text_item{
    width:100vw;
    /*height:25px;*/
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    margin: 2vw 0;
}
.title_item{
    /*width:35vw;*/
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    color:black;
    font-size: 1.3rem;
    font-weight: bold;
}
.author_item{
    /*width:35vw;*/
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    color:#4E4E4E;
    font-size: 14px;
}
.detail_box{
    width:100vw;
    min-height:50%;
}
.navbar{
    width:100vw;
    height:35px;
    display:flex;
    justify-content: flex-start;
    align-items: flex-end;
    flex-wrap: nowrap;
    overflow: hidden;
    border-bottom: 1px solid lightgrey;
    box-sizing: border-box;
}
.navbar_item{
    width:60px;
    height:30px;
    display:flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;

}
.navbar_title{
    width:40px;
    height:25px;
    line-height:25px;
    text-align: center;
    color: black;
    font-size: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;

}
.detail_item{
    width:100vw;
    height:50vw;
}
.bottom_class{
    width:100vw;
    height:9vh;
    position:fixed;
    bottom:0;
    background-color: #FFFFFF;
    border-top:1px solid lightgrey;
}
</style>
